import React from 'react';
import { List, ListItemButton, ListItemAvatar, ListItemText } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

const HowToList = ({ pages }) => {
  return (
    <List>
      {pages &&
        pages.map((page) => (
          <ListItemButton button component="a" href={page.pageUrl} target="_blank">
            <ListItemAvatar>
              <HelpOutlineOutlinedIcon />
            </ListItemAvatar>
            <ListItemText primary={page.title} />
          </ListItemButton>
        ))}
    </List>
  );
};

export default HowToList;
